// src/graphql/userManagement.js
import { gql } from "@apollo/client";

/* -------------------------
   Queries
   ------------------------- */

export const GET_EMPLOYEES = gql`
  query GetEmployees($data: EmployeeFilterInput) {
    getEmployeelist(data: $data) {
      status
      message
      employee {
        id
        fullName
        totalPrice
        contactNumber
        email
        gender
        isOnBoarded
        governmentId
        vehicleId
        license
        radius
        address
        totalDistance
        isDummy
        notifyAdmin
        salaryType
        commissionPercentage
        perDaySalary
        monthlySalary
        joiningDate
        leavingDate
        probationEnds
        employed
        employeechild {
          id
          price
          employeeInventory {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_ADMINS = gql`
  query GetAdmins {
    getAdminList {
      status
      message
      admins {
        id
        fullName
        contactNumber
        email
        isOnBoarded
        gender
      }
    }
  }
`;

export const GET_CUSTOMERS = gql`
  query GetCustomers($contactNumber: String) {
    getUserlist(data: { contactNumber: $contactNumber }) {
      status
      message
      user {
        id
        fullName
        contactNumber
        address {
          line1
          line2
          landMark
          City
          State
          Country
          zipCode
        }
      }
    }
  }
`;

/* -------------------------
   Mutations
   ------------------------- */

export const ADD_ADMIN = gql`
  mutation AddAdmin($data: AdminInput!) {
    addAdmin(data: $data) {
      status
      message
      admin {
        id
        fullName
        contactNumber
        gender
        isOnBoarded
      }
    }
  }
`;

export const UPDATE_ADMIN = gql`
  mutation UpdateAdmin($data: UpdateUserInput!) {
    updateAdmin(data: $data) {
      status
      message
      admin {
        id
        fullName
        contactNumber
        gender
        isOnBoarded
      }
    }
  }
`;

// Employee update/delete live with the screens that use them
// (UserManagement/EditEmployeeForm.jsx, EmployeeDashboard/graphql.js) - the
// copies that were here used input types the backend doesn't have.
export const DELETE_ADMIN = gql`
  mutation DeleteAdmin($data: DeleteByIdInput!) {
    deleteAdmin(data: $data) {
      status
      message
      id
    }
  }
`;
